import { ActionIcon } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import cn from 'classnames';
import * as React from 'react';

import s from './ScrollToBottom.module.scss';

type Props = {
  onClick: () => void;
  className?: string;
};

const ScrollToBottom: React.FC<Props> = ({ onClick, className }) => {
  return (
    <ActionIcon onClick={onClick} size="xl" radius={34} className={cn(s.root, className)} variant="white">
      <IconChevronDown />
    </ActionIcon>
  );
};

export default React.memo(ScrollToBottom);
